import { render, staticRenderFns } from "./courseMassage.vue?vue&type=template&id=1092213a&"
import script from "./courseMassage.vue?vue&type=script&lang=js&"
export * from "./courseMassage.vue?vue&type=script&lang=js&"
import style0 from "./courseMassage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "courseMassage.vue"
export default component.exports